import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PortalApiRepository } from '../../../../core/repositories/portal-api-repository';
import { ProductDetailsResponseDTO, TopicArea } from '../models/ProductDTO';
import { HttpParams } from '@angular/common/http';

interface TypeGetProductDetailsParams {
  quantity: number;
  promotionCode?: string | null;
  selectedCountry?: string | null;
  selectedTopicAreaIds?: string[];
  priceId?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductService extends PortalApiRepository {
  constructor() {
    super();
  }

  getProductDetails(
    params: TypeGetProductDetailsParams,
  ): Observable<ProductDetailsResponseDTO> {
    let queryParams = new HttpParams().append('quantity', params.quantity);

    if (params.priceId) {
      queryParams = queryParams.append('external-price-id', params.priceId);
    } else if (params.selectedTopicAreaIds) {
      queryParams = queryParams.appendAll({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'topic-area-ids': params.selectedTopicAreaIds,
      });
    } else {
      throw new Error(
        'Either priceId or selectedTopicAreaIds must be provided',
      );
    }

    if (params.promotionCode) {
      queryParams = queryParams.append('promotion-code', params.promotionCode);
    }

    if (params.selectedCountry) {
      queryParams = queryParams.append('tax-country', params.selectedCountry);
    }

    const path = '/products';
    return this.get<ProductDetailsResponseDTO>(path, queryParams);
  }

  getTopicAreas(): Observable<TopicArea[]> {
    const path = `/topicAreas/`;
    return this.get<TopicArea[]>(path);
  }
}
